module.exports = __webpack_public_path__ + "static/img/start-btn.c3a526c4.png";